<template>
  <div class="items d-flex flex-column shadow rounded p-2 border border-light" id="editor-mention-list">
    <button
      class="item rounded p-1 border-0 px-2"
      :class="{ 'is-selected': index === selectedIndex }"
      v-for="(item, index) in items"
      :key="index"
      @click="selectItem(index)"
    >
      {{ item.name }}
    </button>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      required: true
    },
    command: {
      type: Function,
      required: true
    }
  },
  data () {
    return {
      selectedIndex: 0
    }
  },
  watch: {
    items () {
      this.selectedIndex = 0
    }
  },
  methods: {
    onKeyDown ({ event }) {
      if (event.key === 'ArrowUp') {
        this.upHandler()
        return true
      }
      if (event.key === 'ArrowDown') {
        this.downHandler()
        return true
      }
      if (event.key === 'Enter') {
        this.enterHandler()
        return true
      }
      return false
    },
    upHandler () {
      this.selectedIndex = ((this.selectedIndex + this.items.length) - 1) % this.items.length
    },
    downHandler () {
      this.selectedIndex = (this.selectedIndex + 1) % this.items.length
    },
    enterHandler () {
      this.selectItem(this.selectedIndex)
    },
    selectItem (index) {
      const item = this.items[index]

      if (item) {
        this.command({ id: item.id, label: item.name })
      }
    }
  }
}
</script>

<style lang="sass">
#editor-mention-list.items
  overflow: hidden
  font-size: 0.9rem
  background: #fff

#editor-mention-list .item
  display: block
  margin: 0
  width: 100%
  text-align: left
  background: #fff

  &:focus
    background-color: #dbdbdb

  &.is-selected
    background-color: #dbdbdb

</style>
